import React from 'react'


export const useFormTitle = () =>{


    function formTitle(t) {
        // Remove hidden <p> tags and their content
        if (typeof t !== "string") return t;

        t = t.replace(/<p\s+hidden=".*?">.*?<\/p>/g, '');

        // Decode URL-encoded characters
        try {
            t = decodeURIComponent(t);
        } catch (e) {
        }

        // Replace special characters with hyphens and clean up
        t = t.replace(/[\[\]]/g, '')             // Remove brackets
            .replace(/\|/g, '-')                         // Replace '|' with '-'
            .replace(/\*/g, '')                          // Remove '*'
            .replace(/[^a-zA-Z0-9\s-]/g, '-')            // Replace special characters with hyphens
            .replaceAll(' ', '-')                        // Replace spaces with hyphens
            .replace(/-+/g, '-')                         // Collapse multiple hyphens
            .replace(/^-|-$/g, '')                       // Trim leading/trailing hyphens
            .toLocaleLowerCase()                                               // Convert to lowercase

        return t;
    }


    return {formTitle}




}